import classNames from 'classnames'

type ProgressBarIconProps = {
  tabTimeOutInSecond: number
  strokeColor?: string
  className?: string
  style?: Record<string, string>
}

const ProgressBarIcon = ({
  tabTimeOutInSecond,
  strokeColor,
  className,
  style,
}: ProgressBarIconProps) => {
  return (
    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="16" cy="16" r="12" stroke="#EFF2F9" strokeWidth="3" />
      <circle
        cx="16"
        cy="16"
        r="12"
        stroke={strokeColor ? strokeColor : '#BEC4D5'}
        strokeWidth="3"
        pathLength="100"
        transform="rotate(-90 16 16)"
        className={classNames(`animate-draw-animation fill-none stroke-blue-50`, className)}
        style={{
          animationDuration: `${tabTimeOutInSecond}s`,
          strokeDasharray: '0 100',
          fill: 'none',
          ...style,
        }}
      />
    </svg>
  )
}

export default ProgressBarIcon
